module.exports = __webpack_public_path__ + "static/media/carousel_3.0816cb2f.jpg";